<template>
  <div class="email-parser">
    <!-- 文件上传 -->
    <div class="upload-box">
      <label class="upload-btn">
        <input type="file" @change="handleFileUpload" accept=".eml" />
        选择 .eml 文件
      </label>
      <p v-if="isLoading">正在解析...</p>
      <p v-if="error" class="error">{{ error }}</p>
    </div>

    <!-- 解析结果 -->
    <div v-if="parsedEmail" class="result">
      <!-- 基础信息 -->
      <div class="email-header">
        <h2>{{ parsedEmail.subject || "（无主题）" }}</h2>
        <p><strong>发件人:</strong> {{ parsedEmail.from }}</p>
        <p><strong>收件人:</strong> {{ parsedEmail.to }}</p>
        <p><strong>日期:</strong> {{ formatDate(parsedEmail.date) }}</p>
      </div>

      <!-- 文本内容 -->
      <div v-if="parsedEmail.text" class="email-text">
        <h3>纯文本内容</h3>
        <pre>{{ parsedEmail.text }}</pre>
      </div>

      <!-- HTML 内容（安全渲染） -->
      <div v-if="parsedEmail.html" class="email-html">
        <h3>HTML 内容</h3>
        <div v-html="sanitizedHtml"></div>
      </div>

      <!-- 附件列表 -->
      <div v-if="hasAttachments" class="attachments">
        <h3>附件（{{ parsedEmail.attachments.length }} 个）</h3>
        <ul>
          <li v-for="(attachment, index) in parsedEmail.attachments" :key="index">
            <button @click="downloadAttachment(attachment)">
              {{ attachment.filename || `附件-${index + 1}` }}
              <span>({{ formatFileSize(attachment.size) }})</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { simpleParser } from 'mailparser';
const MailParser = require("mailparser").simpleParser;
//import DOMPurify from 'dompurify'; // 可选：用于 HTML 内容消毒

export default {
  data() {
    return {
      parsedEmail: null,
      isLoading: false,
      error: null
    };
  },
  computed: {
    sanitizedHtml() {
      //return DOMPurify.sanitize(this.parsedEmail?.html || ''); // 防止 XSS 攻击
    },
    hasAttachments() {
      return this.parsedEmail.attachments.length > 0;
    }
  },
  methods: {
    // 处理文件上传
    async handleFileUpload(event) {
      this.resetState();
      const file = event.target.files[0];
      if (!file) return;

      this.isLoading = true;
      try {
        const emlContent = await this.readFile(file);
        this.parsedEmail =await simpleParser(JSON.stringify(emlContent));
      } catch (err) {
        this.error = `解析失败: ${err.message}`;
        console.error('EML 解析错误:', err);
      } finally {
        this.isLoading = false;
      }
    },

    // 读取文件内容
    readFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(new Error('文件读取失败'));
        reader.readAsBinaryString(file, 'utf-8');
      });
    },

    // 下载附件
    downloadAttachment(attachment) {
      const blob = new Blob([attachment.content], { type: attachment.contentType });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = attachment.filename || 'attachment';
      a.click();
      window.URL.revokeObjectURL(url);
    },

    // 格式化日期
    formatDate(date) {
      return date ? new Date(date).toLocaleString() : '未知时间';
    },

    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    // 重置状态
    resetState() {
      this.parsedEmail = null;
      this.error = null;
    }
  }
};
</script>

<style scoped>
.email-parser {
  margin: 0px auto;
  padding: 0px;
}

.upload-btn {
  display: inline-block;
  padding: 10px 20px;
  background: #007bff;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

input[type="file"] {
  display: none;
}

.error {
  color: #dc3545;
  margin-top: 10px;
}

.result {
  margin-top: 20px;
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 4px;
}

pre {
  white-space: pre-wrap;
  background: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
}

.attachments ul {
  list-style: none;
  padding: 0;
}

.attachments button {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  padding: 5px;
}

.attachments button:hover {
  text-decoration: underline;
}
</style>